import { render, staticRenderFns } from "./file-previewer-dialog.vue?vue&type=template&id=789ba95a&scoped=true"
import script from "./file-previewer-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./file-previewer-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./file-previewer-dialog.vue?vue&type=style&index=0&id=789ba95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ba95a",
  null
  
)

export default component.exports